import { HelpCircle } from "lucide-react"

const FAQ_ITEMS = [
  {
    question: "Gdzie znajdę vape shop w Częstochowie?",
    answer:
      "Vape Shop #Zielarz mieści się przy alei Wolności 17, 42-202 Częstochowa (centrum, kod plus R459+QP). To lokalny sklep vape z e-papierosami, liquidami, solami nikotynowymi i akcesoriami.",
  },
  {
    question: "Co oferuje Vape Shop #Zielarz w Częstochowie?",
    answer:
      "Oferujemy szeroki wybór liquidów, soli nikotynowych, longfilli, e-papierosów oraz akcesoriów do vapingu od sprawdzonych producentów, w przystępnych cenach i z profesjonalnym doradztwem.",
  },
  {
    question: "Jakie są godziny otwarcia vape shopu w Częstochowie?",
    answer:
      "Vape Shop #Zielarz jest otwarty od poniedziałku do piątku w godzinach 8:00–20:00, w soboty 12:00–20:00. W niedziele sklep jest zamknięty.",
  },
  {
    question: "Czy w sklepie kupię liquidy i sole nikotynowe?",
    answer:
      "Tak. W Vape Shop #Zielarz w Częstochowie znajdziesz ponad 100 smaków liquidów i soli nikotynowych, a także longfille i akcesoria. Sprzedaż wyłącznie dla osób pełnoletnich (18+).",
  },
]

export function Faq() {
  return (
    <section id="faq" className="relative py-24">
      {/* Section decorative divider */}
      <div className="absolute top-0 right-0 left-0 h-px bg-gradient-to-r from-transparent via-zielarz-green/30 to-transparent" />

      <div className="mx-auto max-w-3xl px-6">
        {/* Section header */}
        <div className="mb-12 text-center">
          <p className="mb-3 text-sm font-semibold tracking-widest text-zielarz-green uppercase">
            FAQ
          </p>
          <h2 className="mb-4 text-3xl font-extrabold tracking-tight sm:text-4xl">
            Najczęstsze pytania o nasz Vape Shop w Częstochowie
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Wszystko, co warto wiedzieć o Vape Shop #Zielarz – lokalizacja,
            oferta i godziny otwarcia.
          </p>
        </div>

        {/* FAQ list */}
        <div className="space-y-4">
          {FAQ_ITEMS.map((item) => (
            <details
              key={item.question}
              className="group overflow-hidden rounded-2xl border border-border/50 bg-card/50 backdrop-blur-sm transition-all duration-300 hover:border-zielarz-green/30 open:border-zielarz-green/30"
            >
              <summary className="flex cursor-pointer list-none items-center gap-3 p-5 text-left font-bold">
                <HelpCircle className="size-5 shrink-0 text-zielarz-green" />
                <span className="flex-1">{item.question}</span>
                <span className="text-zielarz-green transition-transform duration-300 group-open:rotate-45">
                  +
                </span>
              </summary>
              <div className="px-5 pb-5 pl-13 text-muted-foreground">
                {item.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  )
}
